// Most `toast.error` calls repeat an error the code already reported by hand, so
// reporting every toast as well would double-count them. Toast-sourced reports
// are held back for one window and dropped if an explicit `event_errors` lands
// inside it — which covers both orderings, since some call sites toast first and
// others report first.
//
// Reports are keyed by message: a screen that raises three different errors at
// once still reports three, while the same message toasted twice reports once.
//
// This module holds no imports on purpose. `index.js` marks explicit errors here
// and the toast wrapper reads it back; a shared leaf keeps that from becoming an
// import cycle.
const WINDOW_MS = 700;

let lastExplicitAt = 0;
let pendingReports = new Map();
let pendingTimer = null;

export const noteExplicitError = () => {
  lastExplicitAt = Date.now();
  pendingReports = new Map();

  if (pendingTimer) {
    clearTimeout(pendingTimer);
    pendingTimer = null;
  }
};

export const reportUnlessExplicit = (key, report) => {
  if (Date.now() - lastExplicitAt < WINDOW_MS) return;

  pendingReports.set(key, report);

  if (pendingTimer) return;
  pendingTimer = setTimeout(() => {
    pendingTimer = null;

    const reports = [...pendingReports.values()];
    pendingReports = new Map();
    reports.forEach((run) => run());
  }, WINDOW_MS);
};
